import { ROUTE_STACK_GROUPS, getGroupKeyByRouteName } from './groups'
import {
  buildRecord,
  canUseHistoryGo,
  clearStack,
  getStack,
  markHistorySynced,
  pickCommonQuery,
  setStack
} from './manager'

export { installRouteStack } from './manager'

/** 解析目标路由并返回分组 key */
const resolveGroupKey = (router, options = {}) => {
  const resolved = router.resolve(options)
  return (
    resolved.route.meta?.routeStackGroup ||
    getGroupKeyByRouteName(resolved.route.name)
  )
}

/** 入栈并 push */
export const navigateTo = (router, options = {}) => {
  const groupKey = resolveGroupKey(router, options)
  if (!groupKey) {
    return router.push(options)
  }

  const resolved = router.resolve(options)
  const record = buildRecord(resolved.route)
  const stack = getStack(groupKey)
  const stackList = [...stack]

  const top = stackList[stackList.length - 1]
  if (!top || record.fullPath !== top.fullPath) {
    stackList.push(record)
  }

  setStack(groupKey, stackList)
  markHistorySynced(groupKey)
  return router.push(options)
}

/** 替换栈顶并 replace */
export const redirectTo = (router, options = {}) => {
  const groupKey = resolveGroupKey(router, options)
  if (!groupKey) {
    return router.replace(options)
  }

  const resolved = router.resolve(options)
  const record = buildRecord(resolved.route)
  const stack = getStack(groupKey)
  const nextStack = stack.slice(0, -1)
  nextStack.push(record)

  setStack(groupKey, nextStack)
  return router.replace(options)
}

/** 重启到指定页（等同 goHome） */
export const reLaunch = (router, options = {}) => {
  return goHome(router, options)
}

/** 返回上一页；栈仅一页时 redirect 到父路由 */
export const navigateBack = (router, options = {}) => {
  const currentRoute = router.currentRoute
  const groupKey = currentRoute.meta?.routeStackGroup

  if (!groupKey) {
    if (window.history.length > 1) {
      return router.go(-1)
    }
    return router.replace('/')
  }

  const group = ROUTE_STACK_GROUPS[groupKey]
  const stack = getStack(groupKey)

  if (stack.length > 1) {
    const nextStack = stack.slice(0, -1)
    const prev = nextStack[nextStack.length - 1]
    setStack(groupKey, nextStack)

    if (canUseHistoryGo(groupKey)) {
      return router.go(-1)
    }
    return router.replace({ name: prev.name, query: prev.query })
  }

  const parentName = group.parent[currentRoute.name]
  const query = pickCommonQuery(currentRoute.query, options)

  if (parentName) {
    return redirectTo(router, { name: parentName, query })
  }

  if (window.history.length > 1) {
    return router.go(-1)
  }
  return router.replace(group.externalFallback || '/')
}

/** 回主页并清空路由栈 */
export const goHome = (router, options = {}) => {
  const currentRoute = router.currentRoute
  const groupKey = currentRoute.meta?.routeStackGroup
  const homeRouteName =
    options.homeRouteName ||
    (groupKey && ROUTE_STACK_GROUPS[groupKey]?.home) ||
    'venueManage'
  const query = pickCommonQuery(currentRoute.query, options)

  if (!groupKey) {
    return router.replace({ name: homeRouteName, query })
  }

  const stack = getStack(groupKey)
  const homeRecord = buildRecord(
    router.resolve({ name: homeRouteName, query }).route
  )
  const delta = stack.length - 1

  setStack(groupKey, [homeRecord])

  if (delta > 0 && canUseHistoryGo(groupKey)) {
    return router.go(-delta)
  }
  return router.replace({ name: homeRouteName, query })
}
